export const projectslist = [
  {
    title: "Share-net Bangladesh Video Conferencing platform",
    Url: "https://share-netbangladesh-regional.org/"
  },
  {
    title: "BMMDP (Bangladesh Microinsurance Market Development Program)",
    Url: "https://bmmdp.org/",
  },
  {
    title: "PGCL",
    Url: "https://pgcl.connecteasy.xyz/",
  },
  
  {
    title: "Application System for Notre Dame College",
    Url: "https://ndc.mcampusbd.com/",
  },
  {
    title: "Bangladesh Gas Fields School & College",
    Url: "https://bgfsc.edu.bd/",
  },
  {
    title: "BPDB Phamacy",
    Url: "http://103.106.118.10:8065/",
  },
  {
    title: "Sustainable Coastal & Marine Fisheries Project (Under Department of Fisheries)",
    Url: "http://dof.leotechbd.com/",
  },
  {
    title: "SchoobeeBD",
    Url: "http://schoobeebd.com/",
  },
  {
    title: "Hydrology (Under Bangladesh water Development Board)",
  },
  {
    title: "Online Health Care",
    githubUrl:
      "https://github.com/JabedHossainSwe/Online-Health-Care-Full-Project.git",
  },
  {
    title: "Pharmacy Management System",
    githubUrl:
      "https://github.com/JabedHossainSwe/Pharmacy-Management-System-Using-PHP-MYSQL.git",
  },
  {
    title: "Online Ticket Reservation System",
    githubUrl:
      "https://github.com/JabedHossainSwe/Online-Ticket-Reservation-with-PHP.git",
  },
  {
    title: "And More Projects You will find in my github repo's list",
    githubUrl: "https://github.com/jabedhossainxyz/",
  },
];
